import { registerClientReference } from "react-server-dom-turbopack/server.edge";
export const data = registerClientReference(
    function() { throw new Error("Attempted to call data() from the server but data is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/Discounts.tsx <module evaluation>",
    "data",
);
export default registerClientReference(
    function() { throw new Error("Attempted to call the default export of [project]/src/components/Discounts.tsx <module evaluation> from the server, but it's on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/Discounts.tsx <module evaluation>",
    "default",
);
